import React, { Component } from "react";
import { submitUserMessage } from "../../../services/user/actions";
import SimpleReactValidator from "simple-react-validator";
import { connect } from "react-redux";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      messages: {
        required: localStorage.getItem("fieldValidationMsg"),
        string:   localStorage.getItem("nameValidationMsg"),
        email:    localStorage.getItem("emailValidationMsg"),
        regex:    localStorage.getItem("phoneValidationMsg"),
        min:      localStorage.getItem("minimumLengthValidationMessage"),
      },
    });
  }

  state = {
    name:"", email:"", phone:"", subject:"", message:"",
    loading: false, sent: false,
  };

  _onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  _onSubmit = (e) => {
    e.preventDefault();
    if (
      this.validator.fieldValid("name")    &&
      this.validator.fieldValid("email")   &&
      this.validator.fieldValid("phone")   &&
      this.validator.fieldValid("subject") &&
      this.validator.fieldValid("message")
    ) {
      this.setState({ loading: true });
      this.props.submitUserMessage(
        this.state.name, this.state.email, this.state.phone,
        this.state.subject, this.state.message,
      );
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    const { loading, sent } = this.state;

    return (
      <React.Fragment>
        {/* Contact */}
        <section className="dk-contact-band" id="contact">
          <div className="dk-container">
            <h2>צור עימנו קשר</h2>
            <p>נשמח לעמוד לשירותכם בכל זמן – השאירו הודעה ואנו נחזור אליכם בהקדם</p>
            <a href="https://www.facebook.com/tukto123" className="dk-btn dk-btn--ghost"
              target="_blank" rel="noopener noreferrer" style={{marginBottom:28}}>
              דף פייסבוק שלנו
            </a>

            <div className="dk-contact-card">
              {sent ? (
                <div style={{textAlign:"center",padding:"32px 0"}}>
                  <div style={{fontSize:48,marginBottom:16}}>✓</div>
                  <h3 style={{color:"var(--dk-text)",marginBottom:8}}>ההודעה נשלחה בהצלחה!</h3>
                  <p style={{color:"var(--dk-muted)"}}>נחזור אליכם בהקדם.</p>
                </div>
              ) : (
                <form onSubmit={this._onSubmit} noValidate>
                  <div className="dk-form-row">
                    <div className="dk-field">
                      <label htmlFor="f-name">שם מלא *</label>
                      <input id="f-name" name="name" type="text" value={this.state.name}
                        onChange={this._onChange} placeholder="ישראל ישראלי" autoComplete="name" />
                      {this.validator.message("name", this.state.name, "required|string")}
                    </div>
                    <div className="dk-field">
                      <label htmlFor="f-phone">טלפון *</label>
                      <input id="f-phone" name="phone" type="tel" value={this.state.phone}
                        onChange={this._onChange} placeholder="+972501234567"
                        inputMode="tel" autoComplete="tel" />
                      {this.validator.message("phone", this.state.phone, ["required",{regex:["^\\+[1-9]\\d{1,14}$"]},{min:["8"]}])}
                    </div>
                    <div className="dk-field">
                      <label htmlFor="f-email">אימייל *</label>
                      <input id="f-email" name="email" type="email" value={this.state.email}
                        onChange={this._onChange} placeholder="name@example.com"
                        autoComplete="email" inputMode="email" />
                      {this.validator.message("email", this.state.email, "required|email")}
                    </div>
                    <div className="dk-field">
                      <label htmlFor="f-subject">נושא *</label>
                      <input id="f-subject" name="subject" type="text" value={this.state.subject}
                        onChange={this._onChange} placeholder="נושא הפנייה" />
                      {this.validator.message("subject", this.state.subject, "required|min:6")}
                    </div>
                    <div className="dk-field full">
                      <label htmlFor="f-message">הודעה *</label>
                      <textarea id="f-message" name="message" value={this.state.message}
                        onChange={this._onChange} placeholder="כתבו את הפנייה שלכם כאן..." rows={4} />
                      {this.validator.message("message", this.state.message, "required|min:8")}
                    </div>
                  </div>
                  <div style={{textAlign:"center",marginTop:8}}>
                    <button type="submit" className="dk-btn dk-btn--primary dk-btn--lg"
                      disabled={loading} style={loading?{opacity:.7,cursor:"not-allowed"}:{}}>
                      {loading ? "שולח..." : "שליחת הודעה"}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="dk-footer">
          <div className="dk-container">
            <div className="dk-footer-inner">
              <div className="dk-footer-brand">
                <a href="#home"><img src="/assets/img/logos/logo.png" alt="Tuk.To" /></a>
                <p>עכשיו מכל מכשיר תוכל להגדיר את העסק הקיים או החדש ולהתחיל למכור ביעילות. טוק אחד ואתה שם – Tuk.To זה עסק חכם.</p>
                <div className="dk-footer-social">
                  <a href="https://www.facebook.com/tukto123" target="_blank" rel="noopener noreferrer" aria-label="פייסבוק">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
                  </a>
                  <a href="https://www.instagram.com/tukto123/" target="_blank" rel="noopener noreferrer" aria-label="אינסטגרם">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
                  </a>
                  <a href="https://www.youtube.com/channel/UCl_0k4SBzhqzuSZ4hhaWtVg" target="_blank" rel="noopener noreferrer" aria-label="יוטיוב">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#0F0E1A"/></svg>
                  </a>
                </div>
              </div>

              <div className="dk-footer-col">
                <h6>ניווט באתר</h6>
                <a href="#home">להזמנות</a>
                <a href="#how">איך זה עובד</a>
                <a href="#services">שירותים</a>
                <a href="//my.tuk.to">כניסה / הרשמה לעסקים</a>
                <a href="//my.tuk.to">הרשמה לשליחים</a>
                <a href="//tuk.to/delivery">אפליקציית שליחים</a>
              </div>

              <div className="dk-footer-col">
                <h6>מדיניות</h6>
                <a href="/terms">חוזה התקשרות</a>
                <a href="/usage-policy">מדיניות השימוש</a>
                <a href="/privacy-policy">מדיניות פרטיות</a>
              </div>

              <div className="dk-footer-col">
                <h6>צור קשר</h6>
                <p style={{marginBottom:8}}>מדינת היהודים 42 הרצליה</p>
                <p>הודעה באתר או בפייסבוק ואנו נחזור אליכם</p>
              </div>
            </div>

            <div className="dk-footer-bottom">
              © {new Date().getFullYear()} Tuk.To — כל הזכויות שמורות
            </div>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.user.user, settings: state.settings.settings });
export default connect(mapStateToProps, { submitUserMessage })(Footer);
